<script lang="ts">
  type Screenshot = {
    title: string;
    description: string;
    imagePath: string;
  };

  const screenshots: Screenshot[] = [
    {
      title: 'Dashboard Analytics',
      description: 'Beautiful visualizations show spending patterns, category breakdowns, and trends over time.',
      imagePath: '/screenshots/dashboard.png',
    },
    {
      title: 'Smart Budgeting',
      description: 'Set budgets by category with automatic rollover. See if you\'re on pace with time-aware tracking.',
      imagePath: '/screenshots/budgeting.png',
    },
    {
      title: 'Transaction Management',
      description: 'Filter, search, and categorize transactions with ease. Bulk operations make managing hundreds of transactions simple.',
      imagePath: '/screenshots/transactions.png',
    },
  ];
</script>

<section class="section">
  <div class="container">
    <div class="section-header">
      <h2>Beautifully Simple</h2>
      <p>Powerful analytics without the complexity</p>
    </div>
    <div class="screenshots-grid">
      {#each screenshots as screenshot}
        <div class="screenshot-card">
          <div class="screenshot-image">
            <div class="placeholder">
              <span>Screenshot: {screenshot.title}</span>
              <p class="placeholder-note">Add your actual screenshot to /public{screenshot.imagePath}</p>
            </div>
            <!-- <img src={screenshot.imagePath} alt={screenshot.title} /> -->
          </div>
          <div class="screenshot-info">
            <h3>{screenshot.title}</h3>
            <p>{screenshot.description}</p>
          </div>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  .section {
    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);


  }
  .section-header {
    text-align: center;
    max-width: 700px;
    margin: 0 auto var(--spacing-4xl);
  }

  .section-header h2 {
    font-size: var(--font-size-4xl);
    margin-bottom: var(--spacing-md);
  }

  .section-header p {
    font-size: var(--font-size-xl);
    color: var(--color-text-secondary);
    margin: 0;
  }

  .screenshots-grid {
    display: grid;
    gap: var(--spacing-4xl);
  }

  .screenshot-card {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-3xl);
    align-items: center;
  }

  .screenshot-card:nth-child(even) {
    direction: rtl;
  }

  .screenshot-card:nth-child(even) > * {
    direction: ltr;
  }

  .screenshot-image {
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--shadow-xl);
    border: 1px solid var(--color-border-light);
  }

  .screenshot-image img {
    width: 100%;
    height: auto;
    display: block;
  }

  .placeholder {
    aspect-ratio: 16 / 10;
    background: linear-gradient(135deg, var(--color-background-alt) 0%, var(--color-background-tertiary) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-xl);
    text-align: center;
  }

  .placeholder span {
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-secondary);
    margin-bottom: var(--spacing-sm);
  }

  .placeholder-note {
    font-size: var(--font-size-sm);
    color: var(--color-text-muted);
    max-width: 300px;
    margin: 0;
  }

  .screenshot-info h3 {
    font-size: var(--font-size-2xl);
    margin-bottom: var(--spacing-md);
  }

  .screenshot-info p {
    color: var(--color-text-secondary);
    line-height: var(--line-height-relaxed);
    font-size: var(--font-size-lg);
    margin: 0;
  }

  @media (max-width: 968px) {
    .screenshot-card {
      grid-template-columns: 1fr;
      gap: var(--spacing-xl);
    }

    .screenshot-card:nth-child(even) {
      direction: ltr;
    }
  }
</style>
